<template>
  <div v-if="dataHeader" class="mb-4 mt-sm-2">
    <div
      class="is-flex is-flex-direction-column is-justify-content-center is-align-items-center gap-2 c-w-100"
    >
      <div class="container-project-id bg-lightgray c-w-100" id="containerProjectID">
        <div class="is-flex mb-1 overflow-auto">
          <div class="is-flex flex-sm-column border-right pr-4">
            <p class="label-sm-12">ID (Admin Panel) :</p>
            <p class="averta-black ml-2 mx-sm-0 label-sm-12">
              {{ dataHeader.survey_homecare_id ? `ID${dataHeader.survey_homecare_id}` : '-' }}
            </p>
          </div>
          <div
            class="is-flex flex-sm-column is-justify-content-flex-end px-4"
            :class="{ 'border-right': dataHeader.client_type_tag }"
          >
            <p class="label-sm-12">ID Proyek (Admin Panel) :</p>
            <p class="averta-black ml-2 mx-sm-0 label-sm-12">
              {{ dataHeader.project_homecare_id ? `ID${dataHeader.project_homecare_id}` : '-' }}
            </p>
          </div>
          <div
            v-if="isSMRC && dataHeader.client_external_id"
            class="is-flex flex-sm-column is-justify-content-flex-end px-4 border-left"
            :class="{ 'border-right': dataHeader.client_type_tag }"
          >
            <p class="label-sm-12">{{ TITLE_WO_FULL }}</p>
            <p class="averta-black ml-2 mx-sm-0 label-sm-12">
              {{ dataHeader.client_external_id || '-' }}
            </p>
          </div>
          <div
            class="is-flex flex-sm-column is-justify-content-flex-end px-3"
            v-if="dataHeader.client_type_tag"
          >
            <p class="label-sm-12">Jenis Proyek :</p>
            <div class="is-flex">
              <p class="averta-black ml-2 mx-sm-0 label-sm-12 jenis-proyek">
                {{ dataHeader.client_type_tag }}
              </p>
            </div>
          </div>

          <div
            v-if="dataHeader.wholesale && dataHeader.wholesale.building_type"
            class="is-flex flex-sm-column border-left pl-3 mr-3"
          >
            <p class="label-sm-12">Jenis Bangunan :</p>
            <p class="averta-black ml-2 mx-sm-0 label-sm-12">
              {{ dataHeader.wholesale.building_type }}
            </p>
          </div>
          <div
            v-if="dataHeader.wholesale && dataHeader.wholesale.total_branch"
            class="is-flex flex-sm-column border-left pl-3 mr-3"
          >
            <p class="label-sm-12">Jumlah Cabang :</p>
            <p class="averta-black ml-2 mx-sm-0 label-sm-12">
              {{ dataHeader.wholesale.total_branch }}
            </p>
          </div>
          <div
            v-if="dataHeader.wholesale && dataHeader.wholesale.budget_description && permissionViewBudget"
            class="is-flex flex-sm-column border-left pl-3 mr-3"
          >
            <p class="label-sm-12">Budget :</p>
            <p class="averta-black ml-2 mx-sm-0 label-sm-12">
              {{ dataHeader.wholesale.budget_description }}
            </p>
          </div>
        </div>
        <div class="is-flex flex-sm-column overflow-x-hidden">
          <p class="label-sm-12 title-id-proyek-darurat mr-1">
            ID Proyek Darurat ({{ dataUrgentID.total }}) :
          </p>
          <div class="is-flex c-w-sm-100">
            <div v-if="dataUrgentID.data.length > 0" class="is-flex ml-1 mx-sm-0">
              <p
                class="averta-black ml-1 item-project-urgent label-sm-12"
                v-for="(idProyek, index) in dataUrgentID.data"
                :key="`${index}-proyek-darurat`"
              >
                ID{{ idProyek }}{{ index + 1 === dataUrgentID.data.length ? '' : ';'
                }}{{
                  index + 1 === dataUrgentID.data.length && dataUrgentID.remainData > 0 ? '...' : ''
                }}
              </p>
            </div>
            <p
              v-else
              class="averta-bold-italic color-red label-sm-12"
              :class="{ 'is-clickable': isBS }"
              @click="handleProyekDarurat(true, true)"
            >
              Belum Diatur
            </p>
            <div
              class="is-flex is-align-items-center flex-shrink-0"
              :class="{ 'is-clickable more-wrapper': isBS }"
              @click="handleProyekDarurat(true)"
            >
              <div v-if="isBS" class="ml-2 edit-icon-wrapper">
                <EditIcon color="#d9272d" />
              </div>
              <p
                class="color-red averta-bold is-underlined ml-1 label-sm-12 is-clickable"
                v-if="dataUrgentID.remainData > 0"
              >
                {{ dataUrgentID.remainData }} Lainnya
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- Badge -->
      <div
        v-if="
          (dataHeader.cancelled_at && dataHeader.cancelled_by && dataHeader.cancelled_note) ||
          (dataProps.cancelled_at && dataProps.cancelled_by && dataProps.cancelled_note)
        "
        class="container-project-id bg-lightgray c-w-100 is-flex is-justify-content-center is-align-items-center gap-10"
        :class="isMobile ? 'is-flex-wrap-wrap  is-flex-direction-column' : 'is-flex-direction-row'"
        style="background-color: #b40007 !important"
        id="containerProjectID"
      >
        <div
          class="is-flex is-flex-direction-row is-justify-content-space-between is-align-items-center c-w-100 c-h-100"
        >
          <div
            class="is-flex is-flex-direction-row is-justify-content-flex-start is-align-items-flex-start gap-3 c-w-100"
          >
            <div class="icon-cancel-project">
              <CancelProjectIcon />
            </div>
            <div
              class="is-flex is-flex-direction-column is-justify-content-center is-align-items-flex-start"
            >
              <p class="averta-bold label-16 color-white">Proyek Dibatalkan</p>
              <div
                class="is-flex is-flex-direction-row is-justify-content-flex-start is-align-items-center gap-2 is-flex-wrap-wrap c-w-100"
              >
                <p class="averta-regular label-16 color-white c-w-100">
                  Alasan: {{ dataHeader.cancelled_note || dataProps.cancelled_note }}
                  <b
                    :class="{
                      'is-clickable':
                        (dataHeader?.cancelled_images?.length || 0) > 0 ||
                        (dataProps?.cancelled_images?.length || 0) > 0
                    }"
                    v-if="
                      (dataHeader?.cancelled_images?.length || 0) > 0 ||
                      (dataProps?.cancelled_images?.length || 0) > 0
                    "
                    @click="showCancelModal()"
                  >
                    -
                    {{
                      (dataHeader?.cancelled_images?.length || 0) === 0 &&
                      (dataProps?.cancelled_images?.length || 0) === 0
                        ? 'Tidak ada bukti pembatalan'
                        : 'Lihat Bukti Pembatalan'
                    }}
                  </b>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div
          class="is-flex is-flex-direction-row is-align-items-center gap-3"
          :class="isMobile ? 'is-justify-content-center' : 'is-justify-content-flex-end'"
        >
          <p class="averta-regular label-16 color-white white-space-nowrap">
            Oleh: {{ dataHeader.cancelled_by || dataProps.cancelled_by }} -
            {{
              moment(dataHeader.cancelled_at).format('ddd, D MMM YYYY - HH:mm') ||
              moment(dataProps.cancelled_at).format('ddd, D MMM YYYY - HH:mm')
            }}
          </p>
        </div>
      </div>
      <!-- Badge -->
    </div>
    <ModalProofCancelProject
      :isHandledOpenModalProofCancleProject="isHandledOpenModalProofCancleProject"
      @closeModalProofCancelProject="closeModalProofCancelProject"
      :dataThumbnail="dataHeader.cancelled_images || dataProps.cancelled_images"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { EditIcon, CancelProjectIcon } from '@/components/icons'
import { isSMRC, userMenuPermissions } from '@/helpers'
import { TITLE_WO_FULL } from '@/helpers/constants'
import ModalProofCancelProject from '@/components/modal/ModalProofCancelProject.vue'
import moment from 'moment'

export default {
  name: 'SurveyProjectID',
  props: {
    dataHeaderProps: {
      type: Object,
      required: true
    },
    dataProps: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    EditIcon,
    CancelProjectIcon,
    ModalProofCancelProject
  },
  data () {
    return {
      dataHeader: null,
      dataUrgentID: {
        data: [],
        total: 0,
        remainData: 0
      },
      isHandledOpenModalProofCancleProject: false,
      moment: moment
    }
  },
  computed: {
    ...mapGetters({
      user: 'auth/user'
    }),
    isBS () {
      if (
        this.user.roles[0].name === 'Account Manager' ||
        this.user.roles[0].name === 'Business Support'
      ) {
        return true
      }
      return false
    },
    isSMRC () {
      return isSMRC(this.dataHeaderProps.vendor.code)
    },
    TITLE_WO_FULL () {
      return TITLE_WO_FULL
    },
    isMobile () {
      if (window.innerWidth <= 768) {
        return true
      }
      return false
    },
    permissionViewBudget () {
      return userMenuPermissions('VIEW_BUDGET')
    }
  },
  methods: {
    handleProyekDarurat (value, modeEdit) {
      if (modeEdit && !this.isBS) return
      this.$emit('onModalProyekDarurat', { value, modeEdit })
    },
    checkWidthExceedsParent () {
      const containerProjectUrgent = document.getElementById('containerProjectID').offsetWidth
      const itemProjectUrgent = document.getElementsByClassName('item-project-urgent')
      // const titleIDPROYEK = document.getElementsByClassName('title-id-proyek-darurat').offsetWidth

      let totalWidth = 0
      let indexExceedingWidth = null
      itemProjectUrgent.forEach((item, index) => {
        totalWidth += item.offsetWidth
        if (totalWidth > containerProjectUrgent - 110 && !indexExceedingWidth) {
          indexExceedingWidth = index
        }
      })

      const isMobile = window.innerWidth <= 768

      if (indexExceedingWidth !== null) {
        const limitMobile = indexExceedingWidth - 1
        const limitDekstop = indexExceedingWidth - 4
        const indexExceeding = isMobile ? limitMobile : limitDekstop

        this.dataUrgentID.data = this.dataHeader.project_urgent_id.slice(0, indexExceeding)
        this.dataUrgentID.remainData = this.dataUrgentID.total - this.dataUrgentID.data.length
      }
    },
    loadDataHeader (val, fromWatch) {
      if (val && Object.keys(val).length > 0) {
        this.dataHeader = val
        this.dataUrgentID.data = val.project_urgent_id
        this.dataUrgentID.total = val.project_urgent_id.length

        if (fromWatch) {
          setTimeout(() => {
            this.checkWidthExceedsParent()
          }, 300)
        }
      }
    },
    showCancelModal () {
      this.isHandledOpenModalProofCancleProject = true
    },
    closeModalProofCancelProject () {
      this.isHandledOpenModalProofCancleProject = false
    }
  },
  mounted () {
    this.loadDataHeader(this.dataHeaderProps)
  },
  watch: {
    dataHeaderProps (val) {
      console.log('dataHeaderProps changed', val)
      this.loadDataHeader(val, true)
    },
    dataProps: {
      handler (val) {
        console.log('dataProps changed', val)
      }
    }
  }
}
</script>

<style scoped>
.container-project-id {
  border-radius: 12px;
  padding: 12px;
  min-height: 85px;
}

.border-right {
  border-right: 1px solid #c1c7d3;
}

.border-left {
  border-left: 1px solid #c1c7d3;
}

.container-test {
  width: 5em;
}

.wrapper-test {
  width: 100%;
  display: flex;
}

.more-wrapper {
  margin-top: -6px;
}

.edit-icon-wrapper {
  padding-top: 5px;
  padding-bottom: 2px;
}

.jenis-proyek {
  background: #e1eeff;
  height: max-content;
  padding: 2px 12px;
  border-radius: 100px;
  color: #3185fc;
}
.icon-cancel-project {
  width: 50px;
  min-width: 50px;
  max-width: 50px;
  height: 50px;
  min-height: 50px;
  max-height: 50px;
}
</style>
